module.exports = __webpack_public_path__ + "img/sharedMedias.9d1ec5eb.svg";